var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16.0625C26.2594 16.0625 26.875 15.4469 26.875 14.6875C26.875 13.9281 26.2594 13.3125 25.5 13.3125L25.5 16.0625ZM1.15273 13.7152C0.615757 14.2522 0.615757 15.1228 1.15273 15.6598L9.90318 24.4102C10.4401 24.9472 11.3107 24.9472 11.8477 24.4102C12.3847 23.8732 12.3847 23.0026 11.8477 22.4657L4.06954 14.6875L11.8477 6.90933C12.3847 6.37236 12.3847 5.50175 11.8477 4.96478C11.3107 4.42781 10.4401 4.42781 9.90317 4.96478L1.15273 13.7152ZM25.5 13.3125L2.125 13.3125L2.125 16.0625L25.5 16.0625L25.5 13.3125Z",
    fill: "#AD6BB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.875,
    height: 22,
    fill: "white",
    transform: "translate(0.0625 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.184fd1a7b1fe8fbb64314953582a0a4c.svg";
export { ForwardRef as ReactComponent };